export default __webpack_public_path__ + "static/media/whyUseSmartApy.a095c7c7.svg";